// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loading-event":"_2gPe6","loading-event-overlay":"_5YWWi","loadingImage":"xFv-f","loadingCircle":"pDPYQ","loading-spinner":"tPIo8"};